import { render, staticRenderFns } from "./TrashDetail.vue?vue&type=template&id=765f9dab&"
import script from "./TrashDetail.vue?vue&type=script&lang=js&"
export * from "./TrashDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrashDetail.vue?vue&type=style&index=0&id=765f9dab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports